import { useParams } from "react-router-dom";

import { ROUTES } from "@/config/routes";
import { useGetContentEpisodesSus } from "@/hooks/api/content.hooks";
import { useGetEpisodeHistory } from "@/hooks/api/feed.hooks";

import EpisodeCard from "../cards/EpisodeCard";

interface EpisodeSliders {
  currentSeason: number;
  contentId: number;
}

const DetailEpisodesList = ({ currentSeason, contentId }: EpisodeSliders) => {
  const { id } = useParams();
  const { data: episodes } = useGetContentEpisodesSus(currentSeason);
  const token = localStorage.getItem("splay:token");

  if (!episodes) return <></>;

  const { data: history } = token ? useGetEpisodeHistory(contentId) : { data: { episodes: [] } };

  const getEpisodeHistory = (episodeId: number) => {
    return history?.episodes.find((item) => item.episode_id == episodeId);
  };

  return (
    <div
      className={
        "group/section relative mt-6 grid grid-cols-5 gap-3 max-xl:mt-6 max-xl:grid-cols-4 max-md:grid-cols-3 max-sm:grid-cols-2"
      }
    >
      {episodes.episodes.map((episode) => (
        <EpisodeCard
          key={episode.id}
          episode={episode.episode_numb}
          duration={episode.duration}
          image={episode.picture.resized}
          viewed={getEpisodeHistory(episode.id)?.time_code}
          link={ROUTES.DETAIL.SERIAL_EPISODE.replace(":id", String(id)).replace(":episodeId", String(episode.id))}
        />
      ))}
    </div>
  );
};

export default DetailEpisodesList;
